import { useState, useEffect } from 'react'

const usePrev = <T>(prop: T) => {
  const [prevProp, setPrevProp] = useState<T | null>(null)
  useEffect(() => () => setPrevProp(prop), [prop])
  return prevProp
}

export default usePrev
